import { isApplicantAutomation } from './is-applicant-automation';

import { EMPLOYEE_PERMISSION, HIRING_PERMISSION } from '../../util/permissions';

export const canEditApplicantAutomationOrgDefaults = (user: AuthenticatedUser) =>
  (user.isAccountAdmin && user.hiringPermission === HIRING_PERMISSION.ALL) || user.isAdmin;

export const canEditNonOrgDefaultApplicantAutomations = (user: AuthenticatedUser) =>
  user.hiringPermission === HIRING_PERMISSION.ALL || user.isAdmin;

export const canEditEmployeeAutomations = (user: AuthenticatedUser) =>
  user.employeesPermission === EMPLOYEE_PERMISSION.ALL || user.isAdmin;

export const canViewApplicantAutomations = (user: AuthenticatedUser) =>
  user.hiringPermission === HIRING_PERMISSION.ALL || user.isAdmin;

export const canViewEmployeeAutomations = (user: AuthenticatedUser) =>
  user.employeesPermission === EMPLOYEE_PERMISSION.ALL || user.isAdmin;

export const canDeleteAutomation = (
  automation: ApplicantAutomation | StartDateTriggeredCommunication,
  user: AuthenticatedUser,
) => {
  if (isApplicantAutomation(automation)) {
    return automation.defaultForOrgId
      ? canEditApplicantAutomationOrgDefaults(user)
      : canEditNonOrgDefaultApplicantAutomations(user);
  }

  return canEditEmployeeAutomations(user);
};
